import type { SVGProps } from "react";
import * as React from "react";

const Svg3Layers = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12 2 .447-.894a1 1 0 0 0-.894 0zM2 7l-.447-.894a1 1 0 0 0 0 1.788zm10 5-.447.894a1 1 0 0 0 .894 0zm10-5 .447.894a1 1 0 0 0 0-1.788zM2.447 16.106a1 1 0 1 0-.894 1.788zM12 22l-.447.894a1 1 0 0 0 .894 0zm10.447-4.106a1 1 0 1 0-.894-1.788zm-20-6.788a1 1 0 1 0-.894 1.788zM12 17l-.447.894a1 1 0 0 0 .894 0zm10.447-4.106a1 1 0 1 0-.894-1.788zM11.553 1.106l-10 5 .894 1.788 10-5zm-10 6.788 10 5 .894-1.788-10-5zm10.894 5 10-5-.894-1.788-10 5zm10-6.788-10-5-.894 1.788 10 5zM1.553 17.894l10 5 .894-1.788-10-5zm10.894 5 10-5-.894-1.788-10 5zm-10.894-10 10 5 .894-1.788-10-5zm10.894 5 10-5-.894-1.788-10 5z"
    />
  </svg>
);
export default Svg3Layers;
